export const RESUME_FORMATS = Object.freeze({
  FEDERAL: 'federal',
  PRIVATE: 'private',
});

export const normalizeResumeFormat = (value) =>
  value === RESUME_FORMATS.PRIVATE
    ? RESUME_FORMATS.PRIVATE
    : RESUME_FORMATS.FEDERAL;

export const isFederalResume = (formData = {}) =>
  normalizeResumeFormat(formData.resumeFormat) === RESUME_FORMATS.FEDERAL;

